/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { entity } from '@gh/core-data';
import { TaxRateDto } from './tax-rates.dto';

export const TaxRatesMapper = entity<TaxRateDto>();
